// Registers the service worker for offline support. Only runs in a production
// build — the Vite dev server and a SW caching layer fight over module
// requests, so we skip registration during development.
export function registerServiceWorker() {
  if (!import.meta.env.PROD) return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      // Non-fatal: the app works online without the SW. Log for diagnostics.
      console.warn("Service worker registration failed:", err);
    });
  });
}
